var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.1934V20.1934L10 22.1934V14.1934L4 5.19336V3.19336H20V5.19336L14 14.1934ZM6.404 5.19336L12 13.5874L17.596 5.19336H6.404Z",
    fill: "#09121F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterImg);
export default __webpack_public_path__ + "static/media/FilterImg.25e96a6f91f392e3c470a2c90f1a662a.svg";
export { ForwardRef as ReactComponent };